module.exports = function() {
  return new Worker(__webpack_public_path__ + "fb92654645efe47cf076.worker.js");
};